import React from 'react';
import classnames from 'classnames';

export default function Select({
  id,
  name,
  children,
  className,
  defaultValue,
  disabled,
  spanProps = {},
  value,
  onChange,
  onClick,
  onInput,
  onBlur,
  onFocus,
}) {
  const { className: spanClassName, ...restSpanProps } = spanProps;
  return (
    <span
      className={classnames('icmib-select', spanClassName)}
      {...restSpanProps}
    >
      <select
        className={classnames('icmib-select__select', className)}
        defaultValue={defaultValue}
        disabled={disabled}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onClick={onClick}
        onInput={onInput}
        onBlur={onBlur}
        onFocus={onFocus}
      >
        {children}
      </select>
    </span>
  );
}
